import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/assets/images/mobile-menu/categories/133-moto-ropa-casual.svg")